document.addEventListener("DOMContentLoaded", function() {
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    var roverObj = new Rover({
        "atfSelector" : ".c-site-header__wrapper, [data-location='hero']",
        "trackingSelector" : ".c-cta .js-trackClicks",
        "debug" : false,
        "impressionOptions" : {
            "threshold" : 1
        }
    });


    var formSuccessEvent,
        formStepSuccessEvent,
        formStepSubmitEvent,
        readingScrollEvent,
        reading20SecondEvent,
        chatOpenedEvent;

    window.formSuccessEvent = function(form, props) {
        props = typeof props !== "undefined" ? props : [];
        var props = Object.assign(props, {
            step: 0,
            location: getComponentLocation(form),
            offer: getFormOffer(form),
            action: "Success",
            microIgnore: false,
            nonInteraction: false
        });

        customEvent("Form", props);
    };

    window.formStepSuccessEvent = function(form, props) {
        props = typeof props !== "undefined" ? props : [];
        var props = Object.assign(props, {
            step: getFormCurrentStep(form),
            location: getComponentLocation(form),
            offer: getFormOffer(form),
            action: "Success",
            microIgnore: false,
            nonInteraction: false
        });

        customEvent("Form", props);
    };

    window.formStepSubmitEvent = function(form, props) {
        props = typeof props !== "undefined" ? props : [];
        var props = Object.assign(props, {
            step: getFormCurrentStep(form),
            location: getComponentLocation(form),
            offer: getFormOffer(form),
            action: "Submit",
            microIgnore: false,
            nonInteraction: false
        });

        customEvent("Form", props);
    };

    window.readingScrollEvent = function(depth) {
        customEvent("Reading", {
            action: "Scroll",
            depth: depth,
            microIgnore: false,
            nonInteraction: false
        });
    };

    window.abrEvent = function() {
        customEvent("ABR", {
            action: "20_Seconds",
            microIgnore: false,
            nonInteraction: true
        });
    };

    window.chatOpenedEvent = function() {
        customEvent("Chat", {
            action: "Click",
            microIgnore: false,
            nonInteraction: false
        });
    };

    window.simpleOfferClosed = function(offer) {
        offer = typeof offer !== "undefined" ? offer : null;
        customEvent("CTA", {
            action: "Close",
            location: "simple-offer",
            microIgnore: false,
            nonInteraction: false
        });
    };

    window.simpleOfferMobileClosed = function(offer) {
        offer = typeof offer !== "undefined" ? offer : null;
        customEvent("CTA", {
            action: "Close",
            location: "simple-offer-mobile",
            microIgnore: false,
            nonInteraction: false
        });
    };

    function getComponentLocation(component) {
        var closestLocation = findClosestAncestorWithAttribute(
            component,
            "data-location"
        );
        var component_location = closestLocation?.getAttribute("data-location");

        return component_location;
    }

    function findClosestAncestorWithAttribute(element, attribute) {
        while (element && element !== document) {
            if (element.hasAttribute(attribute)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }

    function getComponentModifiers(component, componentClass) {
        var classes = component.className.split(" ");
        var modifiers = [];

        for (var i = 0; i < classes.length; i++) {
            if (classes[i].startsWith(componentClass + "--")) {
                modifiers.push(classes[i].replace(componentClass + "--", ""));
            }
        }

        return modifiers;
    }

    function getFormOffer(form) {
        var offerInput = form.querySelector("input[name=requested_service]");
        var offer = offerInput ? offerInput.value : null;

        return offer;
    }

    function getFormStepCount(form) {
        var steps = form.querySelector(".c-form__step").length;

        return steps;
    }

    /**
     * getFormCurrentStep - gets current step of a form
     * @param  object form      DOM object of form
     * @return int              current active step of a form
     */
    function getFormCurrentStep(form) {
        //  if no steps found, set step to 0
        var currentStep = form["data-current-step"],
            step = currentStep ? currentStep : 0;

        return step;
    }

    function getClickOffer(clicked) {
        if (clicked.parentNode?.parentNode?.classList.contains("js-toggleLiveChat")) {
            return "LiveChat";
        } else if (clicked.getAttribute("data-offer")) {
            return clicked.getAttribute("data-offer");
        } else {
            return clicked.getAttribute("href");
        }
    }

    function getCTAPosition(cta) {
        var location = findParentWithDataAttribute(cta, "location"),
            ctas = location.querySelectorAll(".c-cta"),
            index = Array.prototype.indexOf.call(ctas, cta),
            position = index + 1;

        return position;
    }

    function getDataTrackingAttributes(el) {
        return Object.keys(el.dataset)
            .filter(key => key.startsWith('track'))
            .reduce((obj, key) => {
                obj[key.replace('track', '').toLowerCase()] = el.dataset[key];
                return obj;
            }, {});
    }

    function getRelativePosition(el) {
        const type = el.dataset.trackType;
        const elements = document.querySelectorAll('[data-track-type="'+type+'"]');
        const index = Array.prototype.indexOf.call(elements, el);
        return index + 1;
    }

    function findParentWithDataAttribute(element, attribute) {
        var parent = element;
        while (parent) {
            if (parent.hasAttribute && parent.hasAttribute("data-" + attribute)) {
                return parent;
            }
            parent = parent.parentNode;
        }
        return null;
    }

    function getVideoPosition(video) {
        var location = video.closest("[data-location]");
        var videos = Array.from(location.querySelectorAll(".c-video"));
        var index = videos.indexOf(video);
        var position = index + 1;
        return position;
    }

    function getCustomTrackingData(el) {
        var clicked = el,
            tracker = closestWithClass(clicked, "js-customTrackingData"),
            location = getComponentLocation(clicked),
            offer = getClickOffer(clicked),
            buttonCopy = clicked.textContent
                .replace(/[^a-zA-Z0-9]+/g, "")
                .trim();

        if (tracker) {
            name = tracker.getAttribute("data-custom-name");
            location = tracker.getAttribute("data-custom-location");
            offer = tracker.getAttribute("data-custom-offer");
            if (tracker.getAttribute("data-custom-step")) {
                var props = {
                    step: tracker.getAttribute("data-custom-step")
                };
            }
        }
        if (clicked.getAttribute("data-custom-copy")) {
            buttonCopy = clicked.getAttribute("data-custom-copy");
        }

        var props = Object.assign(props || {}, {
            location: location,
            offer: offer,
            buttonCopy: buttonCopy,
            action: "Click",
            microIgnore: false,
            nonInteraction: false
        });

        var data = {
            name: name,
            props: props
        };

        return data;
    }

    function closestWithClass(el, className) {
        while (el) {
            if (el.classList.contains(className)) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    }

    function getParentByClass(element, className) {
        while (element && !element.classList.contains(className)) {
            element = element.parentElement;
        }
        return element;
    }

    function getSiblingIndex(element) {
        var index = 0;
        while (element.previousElementSibling) {
            index++;
            element = element.previousElementSibling;
        }
        return index;
    }

    function getTrackingData(el) {
        var clicked = el,
            cta = getParentByClass(clicked, "c-cta"),
            video = getParentByClass(clicked, "c-video"),
            simple = getParentByClass(clicked, "c-simple"),
            simpleMobile = getParentByClass(clicked, "c-simple-mobile"),
            name = "Button",
            location = getComponentLocation(clicked),
            action = "Click",
            props = {};

        if (cta) {
            name = "CTA";
            props = {
                variant: cta.getAttribute("data-variant"),
                modifiers: getComponentModifiers(cta, "c-cta").join(", "),
                position: getCTAPosition(cta)
            };
            props.relativePosition = getRelativePosition(clicked);
            Object.assign(props, getDataTrackingAttributes(clicked));

        } else if (video) {
            name = "Video";
            props = {
                variant: video.getAttribute("data-variant"),
                modifiers: getComponentModifiers(video, "c-video").join(", "),
                position: getVideoPosition(video)
            };

        } else if (simple) {
            name = "CTA";
            location = "simple-offer";
            props = {
                modifiers: getComponentModifiers(simple, "c-simple").join(", ")
            };
            if (clicked.classList.contains("c-simple__close")) {
                action = "Close";
            }
        } else if (simpleMobile) {
            name = "CTA";
            location = "simple-offer-mobile";
            props = {
                modifiers: getComponentModifiers(simpleMobile, "c-simple-mobile").join(", ")
            };
            if (clicked.classList.contains("c-simple-mobile__open_button")) {
                action = "Close";
            }
        } else if (clicked.classList.contains("c-jump-to__link")) {
            var component = getParentByClass(clicked, "c-jump-to");
            name = "Navigation";
            props = {
                copy: clicked.textContent.trim(),
                order: getSiblingIndex(clicked.parentNode) + 1,
                modifiers: getComponentModifiers(component, "c-jump-to").join(
                    ", "
                )
            };
        } else {
            if (clicked.classList.contains("c-button")) {
                props = {
                    modifiers: getComponentModifiers(clicked, "c-button").join(
                        ", "
                    )
                };
            }
        }

        props = Object.assign(props, {
            location: location,
            offer: getClickOffer(clicked),
            buttonCopy: clicked.textContent
                .replace(/[^a-zA-Z 0-9]+/g, "")
                .trim(),
            action: action,
            microIgnore: false,
            nonInteraction: false
        });

        var data = {
            name: name,
            props: props
        };

        return data;
    }

    document.addEventListener("click", function(e) {
        if (
            e.target &&
            e.target.matches("#site-header-nav a:not(.js-trackClicks)")
        ) {
            customEvent("Link", {
                action: "Top Nav",
                label: "url: " + e.target.href
            });
        }
    });

    document.addEventListener("click", function(e) {
        if (e.target && e.target.matches(".c-breadcrumbs a")) {
            customEvent("Link", {
                action: "Breadcrumb",
                label: "url:" + this.href
            });
        }
    });

    document.addEventListener("click", function(e) {
        if (
            e.target &&
            e.target.matches(".c-site-footer a:not(.js-trackClicks)")
        ) {
            customEvent("Link", {
                action: "Footer",
                label: "url: " + this.href
            });
        }
    });

    document.addEventListener("click", ({ target }) => {
        if (target?.matches('main[data-location="page-content"] a:not(.js-trackClicks):not(.js-imageLightbox)')) {
            let href = target.href;
            if (href && href.indexOf(window.location.href + "#") != -1) {
                return;
            }
            customEvent("Link", {
                action: "In Content",
                label: `url: ${href}`
            });
        }
    });

    document.addEventListener("click", function(event) {
        var target = event.target;

        while (target) {
            if (
                target.classList &&
                target.classList.contains("js-trackClicks")
            ) {
                var clicked = event.target,
                    data = getTrackingData(clicked);
                window.customEvent(data.name, data.props);

                break;
            }

            target = target.parentNode;
        }
    });

    document.addEventListener("click", function(event) {
        var target = event.target;

        while (target) {
            if (
                target.classList &&
                target.classList.contains("js-trackCustom")
            ) {
                var clicked = event.target,
                    data = getCustomTrackingData(clicked);
                window.customEvent(data.name, data.props);

                break;
            }

            target = target.parentNode;
        }
    });

    setTimeout(function() {
        abrEvent();
    }, 20000);

    (function(window) {
        var cache = [];
        var scrolled = false;

        /*
         * inArray function borrowed from:
         * jQuery 1.10.1
         * http:jquery.com/
         */
        function inArray(elem, array) {
            var i, length;
            for (i = 0, length = array.length; i < length; i++) {
                if (array[i] === elem) {
                    return i;
                }
            }
            return -1;
        }

        /*
         * Each function borrowed from:
         * jQuery 1.10.1
         * http:jquery.com/
         */
        function each(object, callback) {
            var name;

            for (name in object) {
                if (
                    object.hasOwnProperty(name) &&
                    callback.call(object[name], name, object[name]) === false
                ) {
                    break;
                }
            }
        }

        /*
         * Throttle function borrowed from:
         * Underscore.js 1.5.2
         * http:underscorejs.org
         * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
         * Underscore may be freely distributed under the MIT license.
         */
        function throttle(func, wait) {
            var context, args, result;
            var timeout = null;
            var previous = 0;
            var later = function() {
                previous = new Date();
                timeout = null;
                result = func.apply(context, args);
            };
            return function() {
                var now = new Date();
                if (!previous) {
                    previous = now;
                }
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0) {
                    clearTimeout(timeout);
                    timeout = null;
                    previous = now;
                    result = func.apply(context, args);
                } else if (!timeout) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        }

        function initialScroll() {
            if (!scrolled) {
                scrolled = true;
                //trigger start reading on frist scroll
                if (window && typeof window.readingScrollEvent == "function") {
                    window.readingScrollEvent("Initial");
                }
            }
        }

        function calculatePercentages(docHeight) {
            return {
                "25%": parseInt(docHeight * 0.25, 10),
                "50%": parseInt(docHeight * 0.5, 10),
                "75%": parseInt(docHeight * 0.75, 10),
                //  1px cushion to trigger 100% event in iOS
                "100%": docHeight - 5
            };
        }

        function checkPercentages(
            percentages,
            scrollDistance,
            shouldTriggerEvent
        ) {
            each(percentages, function(key, val) {
                if (inArray(key, cache) === -1 && scrollDistance >= val) {
                    if (shouldTriggerEvent) {
                        // If the depth has not allready been reached, trigger the scroll event
                        if (window) {
                            window.readingScrollEvent(key);
                        }
                    }
                    cache.push(key);
                }
            });
        }

        function checkScroll(shouldTriggerEvent) {
            /*
             * We calculate document and window height on each scroll event to
             * account for dynamic DOM changes.
             */

            var body = document.body,
                html = document.documentElement,
                docHeight = Math.max(
                    body.scrollHeight,
                    body.offsetHeight,
                    html.clientHeight,
                    html.scrollHeight,
                    html.offsetHeight
                ),
                winHeight = window.innerHeight || html.clientHeight,
                scrollTop = body.scrollTop || html.scrollTop,
                //   recalculate percentages on every scroll
                percentages = calculatePercentages(docHeight),
                //   see how far we've scrolled
                scrollDistance = scrollTop + winHeight;

            //   if we've fired off all percentages, then return
            if (cache.length >= 4) {
                return;
            }

            // check for percentage scrolled and see if it matches any of our percentages
            checkPercentages(percentages, scrollDistance, shouldTriggerEvent);
        }

        //on init, check the scroll position, but dont fire off the scrolled event
        checkScroll(false);

        window.onscroll = function() {
            throttle( checkScroll(true), 500);
            throttle( roverObj.checkBTFObserver(), 500);
            initialScroll();
        };
    })(window);
});
